import axios from 'axios';

// Use the obscure admin URL from environment
const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:5000/orbit-control-9e2f1a';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

interface AdminLoginParams {
  email: string;
  password: string;
}

interface AdminLoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    is_admin: boolean;
  };
}

export const adminLogin = async ({ email, password }: AdminLoginParams): Promise<AdminLoginResponse> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/admin-login`, {
      email,
      password
    });
    
    if (response.data.token) {
      // Store the admin token
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminUser', JSON.stringify(response.data.user));
    }
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkAdminAuth = async (): Promise<boolean> => {
  const token = localStorage.getItem('adminToken');
  if (!token) return false;
  
  try {
    const response = await axios.get(`${ADMIN_API_URL}/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

export const adminLogout = (): void => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

export const getAdminToken = (): string | null => {
  return localStorage.getItem('adminToken');
};

export const getAdminUser = (): any => {
  const userStr = localStorage.getItem('adminUser');
  return userStr ? JSON.parse(userStr) : null;
};

// Configure axios interceptor for admin requests
export const configureAdminAxios = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = getAdminToken();
      if (token && config.url?.includes(ADMIN_API_URL)) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

// Initialize admin axios configuration
configureAdminAxios();